import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messages.length)?_c(VSnackbar,{attrs:{"top":"","timeout":8000,"value":_vm.messages.length},on:{"input":function($event){return _vm.MESSAGES_REMOVE()}}},[_vm._v(_vm._s(_vm.messagesJoined)),_c(VBtn,{attrs:{"text":"","color":"pink"},nativeOn:{"click":function($event){return _vm.MESSAGES_REMOVE()}}},[_vm._v("Fermer")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }